<template>
  <v-card v-if="options">
    <v-card-title>
      {{ $t("auditor.auditPeriodClosedAtForm.title") }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t("auditor.auditPeriodClosedAtForm.subtitle") }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="6">
            <v-dialog
              ref="auditPeriodClosedAtDateDialog"
              v-model="auditPeriodClosedAtDateModal"
              :return-value.sync="auditPeriodClosedAtDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="auditPeriodClosedAtDate"
                  :label="$t('auditor.auditPeriodClosedAtForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="auditPeriodClosedAtDate" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="auditPeriodClosedAtDateModal = false">{{
                  $t("action.cancel")
                }}</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.auditPeriodClosedAtDateDialog.save(auditPeriodClosedAtDate)"
                  >{{ $t("action.ok") }}</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog
              ref="auditPeriodClosedAtTimeDialog"
              v-model="auditPeriodClosedAtTimeModal"
              :return-value.sync="auditPeriodClosedAtTime"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="auditPeriodClosedAtTime"
                  :label="$t('auditor.applicationDeadlineForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="auditPeriodClosedAtTimeModal"
                v-model="auditPeriodClosedAtTime"
                format="24hr"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="auditPeriodClosedAtTimeModal = false">{{
                  $t("action.cancel")
                }}</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.auditPeriodClosedAtTimeDialog.save(auditPeriodClosedAtTime)"
                  >{{ $t("action.ok") }}</v-btn
                >
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="update" :loading="loading" color="secondary">
        {{ $t("auditor.applicationDeadlineForm.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UpdateOptionMutation from "@/gql/mutations/UpdateOptionMutation.gql";
import OptionsQuery from "@/gql/queries/auditor/OptionsQuery.gql";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      auditPeriodClosedAtDateModal: false,
      auditPeriodClosedAtTimeModal: false,
      options: null,
      auditPeriodClosedAtDate: null,
      auditPeriodClosedAtTime: null,
    };
  },

  apollo: {
    options: {
      query: OptionsQuery,
      fetchPolicy: "network-only",
      update(data) {
        if (data.options) {
          this.auditPeriodClosedAtDate = data.options
            .find((option) => option.key === "auditPeriodClosedAt")
            ?.value.substr(0, 10);
          this.auditPeriodClosedAtTime = data.options
            .find((option) => option.key === "auditPeriodClosedAt")
            ?.value.substr(11, 5);
        }

        return data.options;
      },
    },
  },

  computed: {
    auditPeriodClosedAt() {
      return `${this.auditPeriodClosedAtDate}T${this.auditPeriodClosedAtTime}:00.000Z`;
    },
  },

  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: UpdateOptionMutation,
        variables: {
          key: "auditPeriodClosedAt",
          value: this.auditPeriodClosedAt,
        },
      });

      this.loading = false;
    },
  },
};
</script>
